import React from 'react';

import { Box } from '@mui/material';
import getEnumTranslation from '@apigrowfinance/pbolt-enum-translation';
import {
    RiErrorWarningLine,
    RiCheckboxCircleLine,
    RiForbidLine,
} from 'react-icons/ri';
import { FormattedMessage } from 'react-intl';

import { LoanItem } from '@clients/domains/lending/lending';
import { LoanStatus } from '@enums/lending/loanStatus';
import loanStatusMessage from '@messages/lending/loanStatus';

export interface LendingProgramStatusProps {
    lendingData: LoanItem;
}

const LendingProgramStatus = ({ lendingData }: LendingProgramStatusProps) => {
    const message = getEnumTranslation(lendingData?.status, {
        messages: loanStatusMessage,
    });
    switch (lendingData?.status) {
        case LoanStatus.PENDING:
        case LoanStatus.PROCESSING:
        case LoanStatus.BOOKED:
            return (
                <>
                    <Box display="flex" mr={1} color="error.main">
                        <RiErrorWarningLine data-testid="warning-icon" />
                    </Box>
                    {message}
                </>
            );
        case LoanStatus.CANCELED:
        case LoanStatus.RENEGOTIATED:
            return (
                <>
                    <Box display="flex" mr={1} color="error.main">
                        <RiForbidLine data-testid="forbidden-icon" />
                    </Box>
                    {message}
                </>
            );
        case LoanStatus.SETTLED:
            return (
                <>
                    <Box display="flex" mr={1} color="success.main">
                        <RiCheckboxCircleLine data-testid="tick-icon" />
                    </Box>
                    <FormattedMessage
                        id="LendingProgramStatus.paid"
                        defaultMessage="Loan paid"
                    />
                </>
            );
    }
    return null;
};

export default LendingProgramStatus;
